import type { Locale } from '../index'

/**
 * Page-body copy for the "this page has moved" signpost at /dashboard — the old
 * way into the customer platform (iteration 0010) — in all three locales
 * (en / zh-Hant / zh-Hans). zh-Hant and zh-Hans are distinct, hand-written
 * translations, never auto-converted from one to the other.
 *
 * The platform is "customer platform" / 客戶平台 / 客户平台 throughout, matching
 * the wording already used in the nav, footer and on /track.
 */
export const moved: Record<Locale, Record<string, string>> = {
  en: {
    'moved.title': 'Page moved',
    'moved.head.description':
      'The customer dashboard has moved to the Geo4Logistics customer platform, at its own address.',
    'moved.h1': 'This page has moved',
    'moved.lead': 'The customer dashboard now lives on the Geo4Logistics customer platform.',
    'moved.card.title': 'The customer platform has a new address',
    'moved.card.body':
      "You've followed an old link. Your shipments, documents and quotes are all on the customer platform now — sign in with the same account.",
    'moved.cta.platform': 'Go to the customer platform',
    'moved.cta.home': 'Back to home',
    'moved.hint.pre': 'Bookmarked the old address? Update it to ',
    'moved.hint.post': '.',
  },
  'zh-Hant': {
    'moved.title': '頁面已搬遷',
    'moved.head.description': '客戶儀表板已搬遷至 Geo4Logistics 客戶平台，並使用專屬網址。',
    'moved.h1': '此頁面已搬遷',
    'moved.lead': '客戶儀表板現已移至 Geo4Logistics 客戶平台。',
    'moved.card.title': '客戶平台已改用新網址',
    'moved.card.body':
      '您開啟的是舊連結。您的貨件、文件與報價現在都在客戶平台上，請使用相同的帳號登入。',
    'moved.cta.platform': '前往客戶平台',
    'moved.cta.home': '返回首頁',
    'moved.hint.pre': '將舊網址加入書籤了嗎？請更新為 ',
    'moved.hint.post': '。',
  },
  'zh-Hans': {
    'moved.title': '页面已迁移',
    'moved.head.description': '客户仪表板已迁移至 Geo4Logistics 客户平台，并使用专属网址。',
    'moved.h1': '此页面已迁移',
    'moved.lead': '客户仪表板现已迁移至 Geo4Logistics 客户平台。',
    'moved.card.title': '客户平台已启用新网址',
    'moved.card.body':
      '您打开的是旧链接。您的货件、文件与报价现在都在客户平台上，请使用相同的账号登录。',
    'moved.cta.platform': '前往客户平台',
    'moved.cta.home': '返回首页',
    'moved.hint.pre': '将旧网址加入书签了吗？请更新为 ',
    'moved.hint.post': '。',
  },
}
